<template>
    <div>
        <slot name="content"></slot>
    </div>
</template>
<script setup></script>
